export default function TDC5GCoverageMap() {
    return (
        <iframe
            allowFullScreen={true}
            aria-label="5G-internet dækningskort"
            height="1000em"
            width="100%"
            src="//daekning.tdc.dk/tdcnetmap_ext_tile2/?tema=all_speed_outdoor_200Mbit_MapTiler"
        ></iframe>
    )
}
